var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as download from "downloadjs";
import * as React from "react";
import { Link } from "react-router-dom";
import { Button, Dimmer, Divider, Grid, Header, Loader, Message } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
import { getWithAuthn } from "../RequestHelpers";
var LabelsModal = /** @class */ (function (_super) {
    __extends(LabelsModal, _super);
    function LabelsModal(props) {
        var _this = _super.call(this, props) || this;
        _this.renderSimpleLabel = function (title, l) {
            return React.createElement(React.Fragment, null,
                React.createElement(Header, null, title),
                copyButton(l),
                React.createElement("pre", null, l.contentLines.join('\n')));
        };
        _this.getLabels = function () {
            _this.setState({
                loading: true,
                error: false
            }, function () {
                getWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.order.id) + "/labels")
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return Promise.resolve(undefined);
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't send email: " + rej);
                });
            });
        };
        _this.downloadButton = function (resp) {
            var handler = function () {
                var contents = [
                    "Order id: " + _this.props.order.id,
                    "User: " + _this.props.order.user.name + " (" + _this.props.order.user.id + ")",
                    "Shipping country code: " + _this.props.order.shippingAddress.countryCode,
                    '',
                    'v3.0 Probe set tubes'
                ]
                    .concat(resp.v3ProbeSetTubeLabels.flatMap(function (l, index) {
                    return ['', "Kit #" + (index + 1), '']
                        .concat(l.contentLines)
                        .concat(['', 'Metadata', ''])
                        .concat(l.extraLines);
                }))
                    .concat(['', '', 'v3.0 Probe sets', ''])
                    .concat(resp.v3ProbeSetBoxLabel.contentLines)
                    .concat(['', '', 'v3.0 Amplifiers', ''])
                    .concat(resp.v3AmplifierBoxLabel.contentLines)
                    .concat(['', '', 'v3.0 Amplifier summary', ''])
                    .concat(resp.v3AmplifierSummary.contentLines)
                    .concat(['', '', 'v3.0 Buffers', ''])
                    .concat(resp.v3BufferVolumeLabel.contentLines)
                    .concat(['', '', 'v3.0 IF Probes', ''])
                    .concat(resp.v3Ihc2Probes.contentLines)
                    .concat(['', '', 'v3.0 IF Probe Summary', ''])
                    .concat(resp.v3Ihc2ProbeSummary.contentLines)
                    .concat(['', '', 'v3.0 IF Buffers', ''])
                    .concat(resp.v3Ihc2BufferVolumeLabel.contentLines)
                    .concat(['', '', 'Gold Probe set tubes', ''])
                    .concat(resp.goldProbeSetTubeLabels.flatMap(function (l, index) {
                    return ['', "Kit #" + (index + 1), '']
                        .concat(l.contentLines)
                        .concat(['', 'Metadata', ''])
                        .concat(l.extraLines);
                }))
                    .concat(['', '', 'Gold Probe sets', ''])
                    .concat(resp.goldProbeSetBoxLabel.contentLines)
                    .concat(['', '', 'Gold Amplifiers', ''])
                    .concat(resp.goldAmplifierBoxLabel.contentLines)
                    .concat(['', '', 'Gold Amplifier summary', ''])
                    .concat(resp.goldAmplifierSummary.contentLines)
                    .concat(['', '', 'Gold Buffers', ''])
                    .concat(resp.goldBufferVolumeLabel.contentLines)
                    .concat(['', '', 'Gold IF Probes', ''])
                    .concat(resp.goldIhc2Probes.contentLines)
                    .concat(['', '', 'Good IF Probe Summary', ''])
                    .concat(resp.goldIhc2ProbeSummary.contentLines)
                    .concat(['', '', 'Gold IF Buffers', ''])
                    .concat(resp.goldIhc2BufferVolumeLabel.contentLines)
                    .concat(['', '', 'RNA-ISH Probe Sets'])
                    .concat(resp.rnaCishProbeSetBoxLabel.flatMap(function (l, index) {
                    return ['', "Kit #" + (index + 1), '']
                        .concat(l.contentLines);
                }))
                    .concat(['', '', 'RNA-ISH Probe Set Tubes'])
                    .concat(resp.rnaCishProbeSetTubeLabels.flatMap(function (l, index) {
                    return ['', "Kit #" + (index + 1), '']
                        .concat(l.contentLines);
                }))
                    .concat(['', '', 'RNA-CISH Protocol', ''])
                    .concat(resp.rnaCishProtocolLabel.contentLines);
                var blob = new Blob([contents.join('\n')], {
                    type: 'text/plain',
                    endings: 'transparent'
                });
                download(blob, "Order " + _this.props.order.id + " labels.txt", 'text/plain');
            };
            return React.createElement(Button, { icon: 'download', label: "Download all", labelPosition: 'left', onClick: handler });
        };
        _this.state = {
            loading: false,
            error: false,
        };
        return _this;
    }
    LabelsModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, null,
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.response &&
                React.createElement(React.Fragment, null,
                    React.createElement(Divider, null),
                    React.createElement("p", null,
                        "Order id: ",
                        this.props.order.id),
                    React.createElement("p", null,
                        "User: ",
                        React.createElement(Link, { to: AppPaths.ADMIN_USER_BASE + "/" + encodeURIComponent(this.props.order.user.id) },
                            this.props.order.user.name,
                            " (",
                            this.props.order.user.id,
                            ")")),
                    React.createElement("p", null,
                        "Shipping country code: ",
                        this.props.order.shippingAddress.countryCode),
                    React.createElement("p", { style: { marginTop: '1rem' } }, this.downloadButton(this.state.response)),
                    React.createElement(Grid, { columns: 2 },
                        React.createElement(Grid.Column, null,
                            React.createElement(Header, null, "v3.0 Probe tubes"),
                            React.createElement("ul", null, this.state.response.v3ProbeSetTubeLabels.map(function (label, index) {
                                return React.createElement("li", { key: index, style: { 'margin': '1.5rem' } },
                                    React.createElement("div", null,
                                        copyButton(label),
                                        React.createElement("pre", null, label.contentLines.join('\n'))),
                                    React.createElement("div", null,
                                        "Metadata",
                                        React.createElement("ul", null, label.extraLines.map(function (line, lineIndex) {
                                            return React.createElement("li", { key: lineIndex }, line);
                                        }))));
                            })),
                            this.renderSimpleLabel('v3.0 Probe sets', this.state.response.v3ProbeSetBoxLabel),
                            this.renderSimpleLabel('v3.0 Amplifiers', this.state.response.v3AmplifierBoxLabel),
                            this.renderSimpleLabel('v3.0 Amplifier Summary', this.state.response.v3AmplifierSummary),
                            this.renderSimpleLabel('v3.0 Buffers', this.state.response.v3BufferVolumeLabel),
                            this.renderSimpleLabel('v3.0 IF Probes', this.state.response.v3Ihc2Probes),
                            this.renderSimpleLabel('v3.0 IF Probe Summary', this.state.response.v3Ihc2ProbeSummary),
                            this.renderSimpleLabel('v3.0 IF Buffers', this.state.response.v3Ihc2BufferVolumeLabel),
                            React.createElement(Header, null, "RNA-ISH Probe Tubes"),
                            React.createElement("ul", null, this.state.response.rnaCishProbeSetTubeLabels.map(function (label, index) {
                                return React.createElement("li", { key: index, style: { 'margin': '1.5rem' } },
                                    React.createElement("div", null,
                                        copyButton(label),
                                        React.createElement("pre", null, label.contentLines.join('\n'))));
                            })),
                            React.createElement(Header, null, "RNA-ISH Probes"),
                            React.createElement("ul", null, this.state.response.rnaCishProbeSetBoxLabel.map(function (label, index) {
                                return React.createElement("li", { key: index, style: { 'margin': '1.5rem' } },
                                    React.createElement("div", null,
                                        copyButton(label),
                                        React.createElement("pre", null, label.contentLines.join('\n'))));
                            })),
                            this.renderSimpleLabel('ISH Platform', this.state.response.rnaCishProtocolLabel)),
                        React.createElement(Grid.Column, null,
                            React.createElement(Header, null, "Gold Probe tubes"),
                            React.createElement("ul", null, this.state.response.goldProbeSetTubeLabels.map(function (label, index) {
                                return React.createElement("li", { key: index, style: { 'margin': '1.5rem' } },
                                    React.createElement("div", null,
                                        copyButton(label),
                                        React.createElement("pre", null, label.contentLines.join('\n'))),
                                    React.createElement("div", null,
                                        "Metadata",
                                        React.createElement("ul", null, label.extraLines.map(function (line, lineIndex) {
                                            return React.createElement("li", { key: lineIndex }, line);
                                        }))));
                            })),
                            this.renderSimpleLabel('Gold Probe sets', this.state.response.goldProbeSetBoxLabel),
                            this.renderSimpleLabel('Gold Amplifiers', this.state.response.goldAmplifierBoxLabel),
                            this.renderSimpleLabel('Gold Amplifier Summary', this.state.response.goldAmplifierSummary),
                            this.renderSimpleLabel('Gold Buffers', this.state.response.goldBufferVolumeLabel),
                            this.renderSimpleLabel('Gold IF Probes', this.state.response.goldIhc2Probes),
                            this.renderSimpleLabel('Gold IF Probe Summary', this.state.response.goldIhc2ProbeSummary),
                            this.renderSimpleLabel('Gold IF Buffers', this.state.response.goldIhc2BufferVolumeLabel)))),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Could not load labels."));
    };
    LabelsModal.prototype.componentDidMount = function () {
        this.getLabels();
    };
    return LabelsModal;
}(React.PureComponent));
export { LabelsModal };
var copyButton = function (label) {
    var handler = function () {
        // navigator.clipboard isn't exposed in TS yet
        var n = navigator;
        n.clipboard.writeText(label.contentLines.join('\n'))
            .catch(function (e) {
            console.log("Could not copy: " + e);
        });
    };
    return React.createElement(Button, { icon: 'copy', label: 'Copy to clipboard', labelPosition: 'left', onClick: handler });
};
//# sourceMappingURL=LabelsModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/LabelsModal.js
// module id = 1194
// module chunks = 0